"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const createIconComponent = _ref => {
  let {
    content
  } = _ref;
  return props => {
    const element = /*#__PURE__*/(0, _react.createElement)(_Icon.default, Object.assign(Object.assign({}, props), {
      viewBox: '0 0 16 16'
    }), content);
    return element;
  };
};
var _default = exports.default = createIconComponent;